import React from "react";
import {CircularProgress} from "@material-ui/core";

export default function Loading() {
    return <CircularProgress style={{color: "#FF0009"}}/>
}